export const APPLY_T = {
  en: {
    langLabel: "Español",
    title: "Join the V2R Masonry Team",
    subtitle: "Fill out this quick application and we'll be in touch.",
    positionQuestion: "Are you applying for a Mason or Laborer position?",
    positionHint: "Choose one to get started.",
    mason: "Mason",
    laborer: "Laborer",
    experienceQuestion: "How many years of masonry experience do you have?",
    experienceHint: "An estimate is fine.",
    yearsLabel: "Years of experience",
    yearsPlaceholder: "e.g. 5",
    back: "Back",
    continue: "Continue",
    applyingFor: "Applying for",
    yrsExp: "yrs experience",
    change: "Change",
    firstName: "First Name *",
    lastName: "Last Name *",
    phone: "Phone Number *",
    email: "Email Address *",
    phoneError: "Please enter a complete 10-digit phone number.",
    yes: "Yes",
    no: "No",
    verification: "Verification",
    submit: "Submit Application",
    submitting: "Submitting...",
    successTitle: "Thank You for Your Application",
    successBody: "Thank you for your application for employment. If there are any open positions or questions, someone will reach out to you shortly. If there are no positions currently available, someone will reach out to you when we have an opening.",
    successPhone: "If you have any questions, please call the office at",
    successEmailNote: "A confirmation email is on its way to",
    successSignature: "V2R Masonry Systems",
    errFill: "Please fill in your name, phone, and email.",
    errPhone: "Please enter a complete 10-digit phone number.",
    errAnswers: "Please answer all Yes/No questions.",
    errYears: "Please enter your years of experience.",
    errVerify: "Please complete the verification check.",
    errGeneric: "Something went wrong. Please try again.",
    questions: {
      reliable_transportation: "Do you have reliable transportation/insurance to and from job sites?",
      background_check: "Can you pass a background check to obtain access to Ft. Hood (and possibly other bases)?",
      acknowledge_manual_labor: "Do you acknowledge that this is an outside position with manual labor?",
      legally_authorized: "Are you legally authorized to work in the U.S.?",
      consent_contact: "Do you consent to Text/SMS and phone calls from V2R Masonry Systems?",
    },
    eeo: "V2R Masonry Systems is an Equal Opportunity Employer. All qualified applicants will receive consideration for employment without regard to race, color, religion, sex, sexual orientation, gender identity, national origin, age, disability, protected veteran status, genetic information, or any other characteristic protected by applicable federal, state, or local law. V2R Masonry Systems participates in E-Verify to confirm employment eligibility and maintains a drug-free workplace.",
  },
  es: {
    langLabel: "English",
    title: "Únase al equipo de V2R Masonry",
    subtitle: "Complete esta breve solicitud y nos comunicaremos con usted.",
    positionQuestion: "¿Está solicitando un puesto de Albañil o de Ayudante?",
    positionHint: "Elija una opción para comenzar.",
    mason: "Albañil",
    laborer: "Ayudante",
    experienceQuestion: "¿Cuántos años de experiencia en albañilería tiene?",
    experienceHint: "Un estimado está bien.",
    yearsLabel: "Años de experiencia",
    yearsPlaceholder: "ej. 5",
    back: "Atrás",
    continue: "Continuar",
    applyingFor: "Solicitando",
    yrsExp: "años de experiencia",
    change: "Cambiar",
    firstName: "Nombre *",
    lastName: "Apellido *",
    phone: "Número de teléfono *",
    email: "Correo electrónico *",
    phoneError: "Ingrese un número de teléfono completo de 10 dígitos.",
    yes: "Sí",
    no: "No",
    verification: "Verificación",
    submit: "Enviar solicitud",
    submitting: "Enviando...",
    successTitle: "Gracias por su solicitud",
    successBody: "Gracias por su solicitud de empleo. Si hay puestos disponibles o preguntas, alguien se comunicará con usted en breve. Si no hay puestos disponibles en este momento, alguien se comunicará con usted cuando tengamos una vacante.",
    successPhone: "Si tiene alguna pregunta, llame a la oficina al",
    successEmailNote: "Le enviamos un correo de confirmación a",
    successSignature: "V2R Masonry Systems",
    errFill: "Complete su nombre, teléfono y correo electrónico.",
    errPhone: "Ingrese un número de teléfono completo de 10 dígitos.",
    errAnswers: "Responda todas las preguntas de Sí/No.",
    errYears: "Ingrese sus años de experiencia.",
    errVerify: "Complete la verificación de seguridad.",
    errGeneric: "Algo salió mal. Inténtelo de nuevo.",
    questions: {
      reliable_transportation: "¿Tiene transporte confiable y seguro para ir y volver de los sitios de trabajo?",
      background_check: "¿Puede pasar una verificación de antecedentes para obtener acceso a Ft. Hood (y posiblemente otras bases militares)?",
      acknowledge_manual_labor: "¿Reconoce que este es un puesto al aire libre con trabajo físico?",
      legally_authorized: "¿Está legalmente autorizado para trabajar en los EE. UU.?",
      consent_contact: "¿Acepta recibir mensajes de texto/SMS y llamadas telefónicas de V2R Masonry Systems?",
    },
    eeo: "V2R Masonry Systems es un empleador que ofrece igualdad de oportunidades. Todos los solicitantes calificados serán considerados para el empleo sin distinción de raza, color, religión, sexo, orientación sexual, identidad de género, origen nacional, edad, discapacidad, condición de veterano protegido, información genética o cualquier otra característica protegida por la ley federal, estatal o local aplicable. V2R Masonry Systems participa en E-Verify para confirmar la elegibilidad de empleo y mantiene un lugar de trabajo libre de drogas.",
  },
};

export const QUESTION_KEYS = [
  "reliable_transportation",
  "background_check",
  "acknowledge_manual_labor",
  "legally_authorized",
  "consent_contact",
];

export const POSITION_LABELS = { mason: "Mason", laborer: "Laborer" };
